import { render, staticRenderFns } from "./addcustomers.vue?vue&type=template&id=270a2672"
import script from "./addcustomers.vue?vue&type=script&lang=js"
export * from "./addcustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports